import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";

const ExportToSheetForm = ({ workspaceId, categories, setPopupShow }) => {
  const [category, setCategory] = useState("");
  const [sheetId, setSheetId] = useState("");
  const [connectedSheets, setConnectedSheets] = useState([]);
  const [loadingSheets, setLoadingSheets] = useState(false);
  const [includeVariants, setIncludeVariants] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    const loadSheets = async () => {
      try {
        setLoadingSheets(true);
        const res = await Utils._apiRequest({
          path: Enums.endpoints.options.LIST,
          type: "GET",
        });
        const options = res.data || [];
        const sheets = options.filter((opt) => opt.group === "tiktok_lising_sheets");
        setConnectedSheets(sheets);
      } catch (err) {
        console.log("Failed to load connected sheets:", err.message);
      } finally {
        setLoadingSheets(false);
      }
    };

    loadSheets();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!category) {
      toast.error("Vui lòng chọn category");
      return;
    }
    if (!sheetId.trim()) {
      toast.error("Vui lòng chọn Google Sheet đã kết nối");
      return;
    }
    try {
      setExporting(true);
      setResult(null);
      const res = await Utils._apiRequest({
        path: Enums.endpoints.products.SHEET_EXPORT_CATEGORY,
        type: "POST",
        payload: {
          workspace: workspaceId,
          category,
          sheetId: sheetId.trim(),
          includeVariants,
        },
      });
      if (res.errors) throw new Error(res.errors);
      setResult(res);
      toast.success(res.message || "Đã export");
    } catch (err) {
      toast.error(err.message || "Lỗi khi export");
    } finally {
      setExporting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="g-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>Category *</Form.Label>
            <Form.Select value={category} onChange={(e) => setCategory(e.target.value)}>
              <option value="">-- Chọn category --</option>
              {categories.map((c) => (
                <option key={c._id} value={c._id}>
                  {c.name} ({c.productCount || 0} sản phẩm)
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group>
            <Form.Label>Google Sheet *</Form.Label>
            <Form.Select value={sheetId} onChange={(e) => setSheetId(e.target.value)} disabled={loadingSheets}>
              <option value="">{loadingSheets ? "Đang tải..." : "-- Chọn Google Sheet đã kết nối --"}</option>
              {connectedSheets.map((sheet) => (
                <option key={sheet.key} value={sheet.key}>
                  {sheet.values?.name || sheet.key}
                </option>
              ))}
            </Form.Select>
            <small className="text-muted d-block mt-2">
              Sản phẩm sẽ được ghi vào sheet có tên
              <code className="mx-1">DRT-[Category]-woo-export</code>
              (tự động tạo nếu chưa có, ghi đè nếu đã có).
            </small>
            {!loadingSheets && !connectedSheets.length && (
              <small className="text-danger d-block mt-2">
                Chưa có Google Sheet nào được kết nối trong Settings.
              </small>
            )}
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Check
            type="checkbox"
            id="include-variants"
            label="Export cả variants (variable product)"
            checked={includeVariants}
            onChange={(e) => setIncludeVariants(e.target.checked)}
          />
          <small className="text-muted d-block">
            Nếu bỏ chọn, chỉ export dạng simple product (bỏ variants).
          </small>
        </Col>
      </Row>

      {result && (
        <Alert variant="success" className="mt-3 mb-0">
          <div>{result.message}</div>
          <small>
            Sheet: <code>{result.sheetName}</code> · Products: {result.productCount} · Rows: {result.rowCount}
          </small>
        </Alert>
      )}

      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button variant="secondary" onClick={() => setPopupShow(false)} disabled={exporting}>
          Đóng
        </Button>
        <Button variant="primary" type="submit" disabled={exporting}>
          {exporting ? "Đang export..." : "Export"}
        </Button>
      </div>
    </Form>
  );
};

export default ExportToSheetForm;
